// Central place for app-specific wording and labels
// Extend this map as your copy evolves.

const VOCAB = {
  appName: "StreamList",

  // Auth / account
  signup: "Join the Guild",
  login: "Present Your Papers",
  logout: "Take Your Leave",
  settings: "Workshop Tools",

  // Actions / navigation
  addToList: "Add to Cabinet",
  favorites: "Treasured Films",
  // Verb/action for favorites button
  markFavorite: "Add to Treasures",
  details: "Open Dossier",
  // Used for the search button text in Movies page
  search: "Summon Films",
  // Used for navbar movies/gazette label
  navGazette: "Gazette",
  share: "Stamp & Send",
  checklist: "Cabinet",
  tasks: "Cabinet",
  cart: "Satchel",
  about: "About the Guild",
};

export default VOCAB;
export { VOCAB };
